import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { FileText, ShieldCheck } from "lucide-react";

export default function Transparency() {
  const { t } = useI18n();
  const [reports, setReports] = useState([]);
  useEffect(() => { api.get("/reports").then(r => setReports(r.data)).catch(() => {}); }, []);
  const commitments = t("transparency.commitments") || [];
  return (
    <div data-testid="transparency-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.transparency.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.transparency.t1")}<br/><span className="italic text-warm-orange">{t("pages.transparency.t2")}</span></h1>
        </div>
      </section>
      <section className="py-20 bg-ivory">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 grid md:grid-cols-2 gap-6">
          {commitments.map((c,i)=>(
            <div key={c} className="card-elev rounded-2xl p-6 flex items-start gap-4" data-testid={`commit-${i}`}>
              <ShieldCheck className="text-green-soft flex-shrink-0" size={26}/>
              <div>
                <h3 className="font-display text-xl text-deep-blue">{c}</h3>
                <p className="text-sm text-deep-blue/60 mt-1">{t("transparency.commitDesc")}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="py-16 bg-pearl">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <h2 className="font-display text-4xl text-deep-blue mb-8">{t("transparency.docsTitle")}</h2>
          {reports.length === 0 ? (
            <div className="p-8 rounded-xl bg-white border border-black/5 text-deep-blue/60 italic">{t("transparency.docsEmpty")}</div>
          ) : (
            <div className="grid md:grid-cols-3 gap-4">
              {reports.map(r => (
                <a key={r.id} href={r.url || "#"} className="card-elev rounded-xl p-5 flex items-center gap-4">
                  <FileText className="text-gold"/>
                  <div>
                    <div className="font-semibold text-deep-blue">{r.title}</div>
                    <div className="text-xs text-deep-blue/60">{r.year} — {r.type}</div>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
